import { GroupEventResponse } from '@moovly/clients/lib/resources/bi/bi.interfaces';
import { t } from '@moovly/i18n';
import * as React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import LogsTableRow from './LogsTableRow';
import { Button } from '@moovly/ui';
import { Table, TableBody, TableHeadCol, TableHeader, TableRow, TableLoader } from '../../../components/Table';

interface LogsTableProps {
  logs: GroupEventResponse[];
  isLoading?: boolean;
  needRefresh?: boolean;
  getMoreLogs: () => void;
}

const LogsTable: React.FC<LogsTableProps> = ({ logs, isLoading = false, needRefresh, getMoreLogs }) => (
  <>
    <InfiniteScroll
      next={getMoreLogs}
      dataLength={logs.length}
      hasMore={true}
      loader={null}
      endMessage={
        <p style={{ textAlign: 'center' }}>
          <b>No more items to load.</b>
        </p>
      }
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHeadCol>{t('statistics.events.headers.createdAtDate')}</TableHeadCol>
            <TableHeadCol>{t('statistics.events.headers.type')}</TableHeadCol>
            <TableHeadCol>{t('statistics.events.headers.user')}</TableHeadCol>
            <TableHeadCol>{t('statistics.events.headers.email')}</TableHeadCol>
            <TableHeadCol>{t('statistics.events.headers.licenseType')}</TableHeadCol>
            <TableHeadCol>{t('statistics.events.headers.executor')}</TableHeadCol>
          </TableRow>
        </TableHeader>
        <TableBody>
          {logs.map((log: GroupEventResponse, key: number) => (
            <LogsTableRow log={log} key={`libraries-table-item-${key}-${log.id}`} />
          ))}
          {isLoading && <TableLoader columnns={6} />}
        </TableBody>
      </Table>
    </InfiniteScroll>
    {needRefresh && <Button label={t('backoffice.logs.retry')} onClick={getMoreLogs} />}
  </>
);

export default LogsTable;
